import { ROUTES } from '@/router/routeNames'
import { PEOPLE_PAGES_PERMISSION } from './peoplePagesAccess'

export default [
  {
    name: ROUTES.PEOPLE,
    path: 'people',
    component: () => import('./pages/RecentVisitors.vue'),
    meta: {
      title: 'People',
      description: 'View the most recently active visitors to your website.',
      requiredPermission: PEOPLE_PAGES_PERMISSION,
      rightyPrompts: [
        {
          label: 'Most engaged',
          drawerLabel: 'Show me my most engaged visitors',
          prompt: 'Show me my most engaged visitors - who has the highest engagement score based on pageviews, survey completions, and segment activity?'
        },
        {
          label: 'Ready to convert',
          drawerLabel: 'Which visitors are ready to convert?',
          prompt: 'Which visitors look ready to convert? Show me people who have seen offers, visited key pages, or shown buying signals.'
        }
      ]
    }
  },
  {
    name: ROUTES.VISITOR_DETAIL,
    path: 'people/:visitorId',
    component: () => import('./pages/VisitorDetail.vue'),
    meta: {
      title: 'Visitor Detail',
      description: 'View complete activity timeline for a specific visitor.',
      requiredPermission: PEOPLE_PAGES_PERMISSION,
      rightyPrompts: [
        {
          label: 'Analyze journey',
          drawerLabel: 'Analyze this visitor\'s journey',
          prompt: 'Pull this visitor\'s full profile and activity timeline, then give me a complete analysis: list every page they visited (with visit counts), identify their interests based on content patterns, show all segment memberships and ESP data (tags, custom fields), summarize any flow/survey interactions, and note their device, location, and engagement level. Present everything in a single structured response — don\'t ask me questions first.'
        },
        {
          label: 'Next best action',
          drawerLabel: 'What should I do next with this visitor?',
          prompt: 'Pull this visitor\'s full profile and activity timeline first. Then based on their page visits, segments, ESP tags, and flow activity, tell me: what are they most interested in, where are they in the buying journey, and what specific content, offer, or outreach would be most effective right now? Give me concrete, actionable recommendations — not generic advice.'
        }
      ]
    }
  }
]
